import { createDefaultDashboardVisibilityState, resetDashboardRuntimeEditorState } from './helpers/DashboardWidgetDataProviderState';
import dashboardWidgetDataProviderBase from './helpers/DashboardWidgetDataProviderBase';
import dashboardWidgetDataProviderWidgets from './helpers/DashboardWidgetDataProviderWidgets';
import dashboardWidgetDataProviderDashboard from './helpers/DashboardWidgetDataProviderDashboard';

/**
 * Dashboard-specific provider that translates between backend dashboard data
 * and the editor-friendly widget and breakpoint state.
 */
export default class DashboardWidgetDataProvider {
    /**
     * Create a dashboard data provider instance.
     *
     * @param {*} id
     * @param {*} queryParams
     */
    constructor(id, queryParams) {
        this.id = id;
        this.queryParams = queryParams;
        this.vue = window.AppKit.getApp();

        this.bindEditorProviderMethods();
        this.title = this.translate('Dashboard');
        this.dashboardTabs = [];
        resetDashboardRuntimeEditorState(this);
    }

    get supportedBlocks() {
        return this.supportedWidgets;
    }

    get blockGroupings() {
        return this.widgetGroupings;
    }
}

Object.assign(
    DashboardWidgetDataProvider.prototype,
    dashboardWidgetDataProviderBase,
    dashboardWidgetDataProviderWidgets,
    dashboardWidgetDataProviderDashboard,
);
